import React from 'react'

const NoResults = ({ message }) => {
  return (
    <div className="d-flex justify-content-center align-items-center w-100">
      <h4>{message}</h4>
    </div>
  )
}

export default NoResults